<section class="error-page">
  <h1 class="error-page__code">500</h1>
  <p class="error-page__message">Something went wrong on our end. Please try again later.</p>
</section>
